// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nn-0";
export var assigneeDetails = "_nn-1";
export var assigneeInfo = "_nn-2";
export var dropdownContainer = "_nn-4";
export var dropdownImage = "_nn-5";
export var editAssigneeInfo = "_nn-3";
export var editAssigneeModalContainer = "_nn-6";
export var hidden = "_nn-8";
export var input = "_nn-7";